var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pub-info-list-item"},[_c('p',{staticClass:"info-label"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"info_value_content"},[_c('p',{staticClass:"info-value"},[_vm._v(_vm._s(_vm.value))]),_c('p',{staticClass:"info-unit"},[_vm._v(_vm._s(_vm.unit))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }